<template>
    <div class="configuracoes-container">
      <div class="page-header">
        <h1 class="text-h4 font-weight-bold text-grey-darken-1">
          <v-icon class="mr-2">mdi-cog</v-icon>
          Configurações
        </h1>
        <p class="text-subtitle-1 text-grey-darken-1">
          Configure parâmetros do sistema e integrações
        </p>
      </div>
  
      <v-card>
        <v-card-text class="pa-6">
          <div class="text-center py-8">
            <v-avatar size="80" color="grey-lighten-3" class="mb-4">
              <v-icon size="40" color="grey-darken-1">mdi-cog</v-icon>
            </v-avatar>
            <h3 class="text-h6 text-grey mb-2">Configurações</h3>
            <p class="text-grey">Esta funcionalidade será implementada em breve</p>
          </div>
        </v-card-text>
      </v-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Configuracoes'
  }
  </script>
  
  <style scoped>
  .configuracoes-container {
    padding: 24px;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    min-height: 100vh;
  }
  
  .page-header {
    margin-bottom: 24px;
  }
  </style>